import { GraphicsInfo } from "./graphics-info";
import { Subject } from "rxjs";
import moment from "moment";

export abstract class GraphicsRepository {
  graphicUpdated: Subject<GraphicsInfo>;

  templateDeleted: Subject<{}>;

  getTemplatesNamesAndIds: () => Promise<any>;

  getAll: () => Promise<GraphicsInfo[]>;

  getGraphicsSearch: (
    searchQuery: string,
    orderByGraphics: number,
    sortByGraphics: string,
    startDateCreatedGraphics: moment.Moment,
    endDateCreatedGraphics: moment.Moment,
    templateIds: number[],
  ) => Promise<GraphicsInfo[]>;

  getGraphics: (id: number) => Promise<GraphicsInfo>;

  getGraphicsTemplate: (id: number) => Promise<GraphicsInfo>;

  save: (graphicsInfo: GraphicsInfo) => Promise<void>;

  setGoLive: (graphicsInfo: GraphicsInfo) => Promise<void>;

  graphicsUpload: (
    url: string,
    filename: string,
    graphicsName: string,
    graphicsDescription: string,
  ) => Promise<void>;

  thumbnailUpload: (
    url: string,
    filename: string,
    graphicId: number,
  ) => Promise<void>;

  sampleVideoUpload: (
    url: string,
    filename: string,
    graphicsId: number,
  ) => Promise<void>;

  fontUpload: (url: string, filename: string) => Promise<void>;

  deleteGraphics: (graphicsId: number) => Promise<void>;

  updateRenditionValidityPeriod: (
    graphicTemplateId: number,
    renditionValidityPeriodMs: number,
  ) => Promise<void>;

  deleteInstance: (instanceId: number) => Promise<void>;
}
